import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "circle", "hiddenField"]

  connect() {
    const isChecked = this.hiddenFieldTarget.value === "1"
    this.updateToggleState(isChecked)
  }

  toggle() {
    const currentValue = this.hiddenFieldTarget.value
    const newValue = currentValue === "1" ? "0" : "1"

    this.hiddenFieldTarget.value = newValue
    this.updateToggleState(newValue === "1")
  }

  updateToggleState(isEnabled) {
    if (isEnabled) {
      this.buttonTarget.classList.remove("bg-gray-200")
      this.buttonTarget.classList.add("bg-[#0352ff]")
      this.buttonTarget.setAttribute("aria-checked", "true")

      this.circleTarget.classList.remove("translate-x-0")
      this.circleTarget.classList.add("translate-x-3.5")
    } else {
      this.buttonTarget.classList.remove("bg-[#0352ff]")
      this.buttonTarget.classList.add("bg-gray-200")
      this.buttonTarget.setAttribute("aria-checked", "false")

      this.circleTarget.classList.remove("translate-x-3.5")
      this.circleTarget.classList.add("translate-x-0")
    }
  }
}
